module.exports = __webpack_public_path__ + "img/A5-5-plan.5ecf079a.png";